module.exports = __webpack_public_path__ + "img/136.a12478b8.jpg";